import ApprovalStateTag from './ApprovalStateTag';

export default ApprovalStateTag;
